import { connect } from "react-redux"
import View from "./view"
import { Store } from "utilities/Redux/store"
import { getOpenOfferRequestIdsForBuyer } from "modules/Buyer/OfferRequests/selectors"

const mapStateToProps = (state: Store) => ({
  offerRequestIds: getOpenOfferRequestIdsForBuyer(state),
})

export default connect(mapStateToProps)(View)
